import { render } from "./inseratEntry.vue?vue&type=template&id=3308d9a7&scoped=true"
import script from "./inseratEntry.vue?vue&type=script&lang=js"
export * from "./inseratEntry.vue?vue&type=script&lang=js"

import "./inseratEntry.vue?vue&type=style&index=0&id=3308d9a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3308d9a7"

export default script